<template>
  <b-modal id="placeOrderTax"
           :lazy="true"
           @ok="placeOrder"
           :ok-disabled = "!placing"
           title="Confirm your order"
           ok-title = "Place Order"
           @show="getTax">

      <m-loader size="box" :show="loading"/>
      <div v-show="!loading">
        <table>
          <tr>
            <td>Sub Total:</td>
            <td data-test="summary-tax-subPrice">{{tax.SubTotal | numberFormat}}</td>
          </tr>
          <tr>
            <td>Tax Price:</td>
            <td data-test="summary-tax-taxPrice">{{tax.TotalTax | numberFormat}}</td>
          </tr>
          <tr v-if="order.PromotionAmount>0">
            <td>Promotion Deducted:</td>
            <td data-test="summary-tax-taxPrice">{{order.PromotionAmount | numberFormat("$", 2)}}</td>
          </tr>
          <tr>
            <td>Total Price:</td>
            <td data-test="summary-tax-totalPrice"> {{tax.Total | numberFormat}}</td>
          </tr>
        </table>
      </div>
  </b-modal>

</template>

<script>
  import utils from '@/assets/utils'
  import notificaton from '@/components/common/notification'
  export default {
    components: {
    },
    created () {
    },
    data () {
      return {
        tax: {},
        loading: true,
        placing: false
      }
    },
    computed: {
      order () {
        return this.$store.state.order
      }
    },
    methods: {
      getTax () {
        this.loading = true
        this.placing = false
        this.$http.post('PlaceOrder.aspx/CalculateTax', {
          req: {
            AddressLine: this.order.OrderContactInformation.AddressLine,
            City: this.order.OrderContactInformation.City,
            Country: this.order.OrderContactInformation.CountryCode,
            DesiredQty: this.order.TotalDesiredQty,
            ListType: this.order.ListType,
            OrderAmount: this.order.TotalEstmCost,
            OrderNumber: '',
            State: this.order.OrderContactInformation.State,
            TaxAmount: 0,
            UserId: 0,
            Zip: this.order.OrderContactInformation.Zipcode
          }
        }).then(resp => {
          if (resp.body.d.ResultFlag) {
            this.loading = false
            this.placing = true
            this.tax = resp.body.d.DataSource

            this.$store.commit('order/saveKey', ['TaxCharge', this.tax.TotalTax])
            this.$store.commit('order/saveKey', ['OrderCharge', this.tax.SubTotal])
            this.$store.commit('order/saveKey', ['TotalActualCost', this.tax.Total])
          }
        }, resp => {
          this.loading = false
          this.placing = false
        })
      },
      placeOrder () {
        this.placing = false
        this.$http.post('PlaceOrder.aspx/ProcessOrder', {
          currentSessionId: this.$store.state.site.CurrentSessionId,
          industry: '',
          licenseName: '',
          password: '',
          sanExpDate: '',
          sanNumber: '',
          order: this.order
        }).then(resp => {
          this.placing = true
          let data = resp.body.d.DataSource
          if (!data.IsSuccess) {
            notificaton.notice('error', 'Unfortunately, the system is unable to process your request. Our technical support specialists have been notified. Thank you for your patience while we work to resolve the error.',
              {title: 'Place Order Error', onlyGroup: 'placeOrderError'})
            return false
          }

          this.$store.commit('order/saveKey', ['OrderCode', data.OrderCode])
          this.$store.commit('order/saveKey', ['AccountName', data.AccountName])
          this.$store.commit('order/saveKey', ['SessionGuid', data.OrderSessionGuid])
          this.$store.commit('order/saveKey', ['OrderSubmittedDate', data.OrderSubmittedDate])
          this.$store.commit('order/saveKey', ['CurrentStep', 'success'])

          utils.uaEcommerce(this.$store.state.order,
            this.$store.getters['config/datasource'].name,
            this.$store.getters['config/datasource'].SKU)
          this.$router.push({path: 'success'})

          // update user point
          // TODO@PONY need to use new api
          this.$http.post('LandingPage.aspx/GetUserPoint', {}).then(resp => {
          }, resp => {
            this.$store.commit('user/saveKey', ['userPoint', resp.body.d.DataSource.UserPoint])
          })
        }, resp => {
          this.placing = true
        })
      }
    }
  }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/summary/MPlaceOrderTax.vue